export default __webpack_public_path__ + "../staticImages/sprite-visa-2x.png";